import {
  Module, VuexModule, getModule, Mutation, Action,
} from '@compassdigital/vuex-module-decorators';
import store from '@/store';
import {
  MarketsApi, Market, Sector, SectorsApi, Settings, SettingsApi,
} from '@compassdigital/foodworks.ts.sdk';
import ConfigUtil from '@/util/ConfigUtil';
import AppModule from '@/store/modules/app';

interface ISystemModule {
  markets: Market[];
  sectors: Sector[];
  activeEventThreshold: Array<string>;
}
@Module({
  dynamic: true,
  name: 'system',
  namespaced: true,
  store,
})
class SystemModule extends VuexModule implements ISystemModule {
  public markets: Market[] = [];

  public sectors: Sector[] = [];

  public cuisines: string[] = [];

  public activeEventThreshold = ['3'];

  @Mutation
  public SET_MARKETS(markets: Market[]) {
    this.markets = ConfigUtil.filterMarket(markets);
  }

  @Mutation
  public SET_SECTORS(sectors: Sector[]) {
    this.sectors = ConfigUtil.filterSector(sectors);
  }

  @Mutation
  public SET_SETTINGS(settings: Settings) {
    this.cuisines = settings.cuisineTypes || [];
    this.activeEventThreshold = (settings as any).activeEventThreshold || ['3'];
  }

  /**
   *
   */
  @Action
  public async fetchMarkets() {
    const api = new MarketsApi(AppModule.apiConfig);
    const markets = await api.getMarkets();
    this.SET_MARKETS(markets.data);
  }

  /**
   *
   */
  @Action
  public async fetchSectors() {
    const api = new SectorsApi(AppModule.apiConfig);
    const sectors = await api.getsSectors();
    this.SET_SECTORS(sectors.data);
  }

  /**
   *
   */
  @Action
  public async fetchSettings() {
    const api = new SettingsApi(AppModule.apiConfig);
    const settings = (await api.getSettings()).data;
    this.SET_SETTINGS(settings);
  }
}

export default getModule(SystemModule);
